export default "__VITE_ASSET__CMLOnJ14__"